module.exports = __webpack_public_path__ + "img/quality-1.82a1c7e3.png";